/**
 * 对指定日期进行格式化
 * @param date { Date } 要格式化的日期对象
 * @param pattern { String } 格式化模板，支持 yyyy-MM-dd、yyyy-MM-dd hh:mm:ss等，注意大小写
 */
export var formatDate = function (date, pattern) {
    if (date === void 0) { date = new Date(); }
    if (pattern === void 0) { pattern = 'yyyy-MM-dd'; }
    var o = {
        'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
    };
    // y+ 指的是匹配y 1次或多次
    // (y+) ()称为捕获括号, 匹配 y+并且捕获匹配项
    // 当pattern中需要有年的时候
    if (/(y+)/.test(pattern)) {
        // https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/RegExp
        // RegExp.$1 是被匹配的子字符串,注意,该特性非标准. 不属于当前的任何规范.
        pattern = pattern.replace(RegExp.$1, "" + (date === null || date === void 0 ? void 0 : date.getFullYear())).substr(4 - RegExp.$1.length);
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(pattern)) {
            pattern = pattern.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return pattern;
};
/**
 * 通过Date对象获取的month、date、hour、minute不满10的前面补0
 */
export var zeroFill = function (val) {
    if (val < 10) {
        val = "0" + val;
    }
    return val;
};
/**
 * 获取英文26个英文字母，默认小写lowerCase, 大写传upperCase
 */
export var getEnLetters = function (type) {
    if (type === void 0) { type = 'lowerCase'; }
    var result = [];
    var index = 0;
    for (var i = 97; i < 123; i++) {
        result[index] = String.fromCharCode(i);
        index++;
    }
    if (type === 'upperCase') {
        result = result.map(function (item) {
            return item.toUpperCase();
        });
    }
    return result;
};
/**
 * query: Object
 * str: String
 * 返回url中query拼接成的字符串
 */
export var getUrlQueryString = function (query) {
    var str = '';
    if (Object.keys(query).length) { // 判断query是否有值
        var queryArr = Object.entries(query);
        for (var _i = 0, queryArr_1 = queryArr; _i < queryArr_1.length; _i++) {
            var queryItem = queryArr_1[_i];
            str += queryItem.join('=') + "&";
        }
    }
    if (str) { // 去掉最后一个&
        str = str.substring(0, str.length - 1);
    }
    return str;
};
/**
 * @param {*} year 年份
 * @param {*} month 月份
 * @param {*} weekIndex 周的索引（一个月的第几周）
 */
export var getFirstDayOfWeek = function (year, month, weekIndex) {
    var firstDayOfMonth = new Date(year, month, 1); // 当前月的第一天
    var day = firstDayOfMonth.getDay(); // 当前月的第一天是周几
    var value = day > 0 ? (1 - day) : -6; // 偏移天数， day是0的时候刚好是周日
    // weekIndex 当前月的第几周
    return new Date(year, month, value + (weekIndex - 1) * 7); // 一个月的某个星期的第一天
};
/**
 * @param {*} date 时间戳
 * @param {*} weekIndex 周的索引
 */
export var getDateByWeek = function (date, weekIndex) {
    var year = date.getFullYear(); // 当前年
    var month = date.getMonth(); // 当前月
    var firstDayOfFirstWeek = getFirstDayOfWeek(year, month, weekIndex);
    var days = [];
    for (var i = 0; i < 7; i++) {
        // +1 是因为默认一周是周日为第一天，周日是0，此处是以周一为一周的第一天
        firstDayOfFirstWeek.setDate(firstDayOfFirstWeek.getDate() + 1);
        days.push({
            date: firstDayOfFirstWeek.getDate(),
        });
    }
    return days;
};
/**
 * @param {*} year 年
 * @param {*} month 月
 */
export var getMonthWeekCount = function (year, month) {
    if (year === void 0) { year = new Date().getFullYear(); }
    if (month === void 0) { month = new Date().getMonth(); }
    var lasetDate = new Date(year, month + 1, 0); // 当前月最后一天
    var curDay = lasetDate.getDay(); // 最后一天是周几
    // https://segmentfault.com/q/1010000011402629?sort=created
    var curDate = lasetDate.getDate(); // 最后一天是几号
    // 一周的开始以周一为开始，6 - curDay = 当前周的还有几天过完
    return Math.ceil((curDate + 6 - curDay + 1) / 7);
};
/**
 * @description: 富文本会在内容末添加一段广告html，通过下面的函数清除广告html，并返回清除后的html内容
 * @param {type} html 富文本编辑器编辑后，保存表单前将html内容传入 clearFroalaEditorAdHtml => clearRichTextEditorAdHtml 改名
 * @return:
 */
export function clearRichTextEditorAdHtml(html) {
    var obj = document.createElement('div');
    obj.innerHTML = html;
    var adNode = obj.querySelector('[data-f-id="pbf"]');
    adNode && adNode.remove();
    return obj.innerHTML || '';
}
